import { get } from 'lodash'
import type { RootState as State } from '~/services/store'
import type { AdminSummary } from '~/features/admin/adminSlice'

export const
  selectHasInitializedAdminData = (state: State): boolean => get(state, 'admin.hasInitializedAdminData'),
  selectAdminSummary = (state: State): AdminSummary => get(state, 'admin.summary')
